// extracted by mini-css-extract-plugin
export default {"whDomainsContainer":"Domains-whDomainsContainer_Lg20J"};